import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "text-bold"
};
import { computed, toRefs } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Banner',
    props: {
        isDense: {
            type: Boolean,
            default: false
        },
        isVisible: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: ''
        },
        message: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'warning',
            validator: (v) => v === 'warning' || v === 'error' || v === 'success' || v === 'info'
        },
        hasAction: {
            type: Boolean,
            default: false
        },
        actionLabel: {
            type: String
        },
        customIcon: {
            type: String,
            default: ''
        }
    },
    emits: ["action"],
    setup(__props, { emit: __emit }) {
        const BANNER_STYLES = {
            warning: {
                classes: 'background-yellow border-yellow',
                icon: 'fa-solid fa-triangle-exclamation',
                iconColor: 'warning'
            },
            error: {
                classes: 'background-red border-red',
                icon: 'fa-solid fa-circle-exclamation',
                iconColor: 'red'
            },
            success: {
                classes: 'background-green border-green',
                icon: 'fa-solid fa-circle-check',
                iconColor: 'positive'
            },
            info: {
                classes: 'background-blue border-blue',
                icon: 'fa-solid fa-circle-info',
                iconColor: 'blue'
            }
        };
        const emit = __emit;
        const props = __props;
        const { isDense, isVisible, title, message, type, hasAction, actionLabel, customIcon } = toRefs(props);
        /**
         * Get the classes of the banner.
         * @returns {string} The classes of the banner.
         */
        const bannerClasses = computed(() => BANNER_STYLES[type.value].classes);
        /**
         * Get the icon of the banner.
         * @returns {string} The icon of the banner.
         */
        const icon = computed(() => customIcon.value || BANNER_STYLES[type.value].icon);
        /**
         * Get the color of the icon.
         * @returns {string} The color of the icon.
         */
        const iconColor = computed(() => BANNER_STYLES[type.value].iconColor);
        /**
         * Check if the title is present.
         * @returns {boolean} True if the title is present, false otherwise.
         */
        const hasTitle = computed(() => !!title.value);
        return (_ctx, _cache) => {
            const _component_q_icon = _resolveComponent("q-icon");
            const _component_q_btn = _resolveComponent("q-btn");
            const _component_q_banner = _resolveComponent("q-banner");
            return (_unref(isVisible))
                ? (_openBlock(), _createBlock(_component_q_banner, {
                    key: 0,
                    class: _normalizeClass(['full-width', bannerClasses.value]),
                    rounded: "",
                    "inline-actions": "",
                    dense: _unref(isDense)
                }, _createSlots({
                    avatar: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                            name: icon.value,
                            color: iconColor.value
                        }, null, 8, ["name", "color"])
                    ]),
                    default: _withCtx(() => [
                        (hasTitle.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(title)) + ": ", 1))
                            : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_unref(message)) + " ", 1)
                    ]),
                    _: 2
                }, [
                    (_unref(hasAction))
                        ? {
                            name: "action",
                            fn: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                    onClick: _cache[0] || (_cache[0] = ($event) => (emit('action'))),
                                    label: _unref(actionLabel),
                                    "text-color": iconColor.value,
                                    flat: ""
                                }, null, 8, ["label", "text-color"])
                            ]),
                            key: "0"
                        }
                        : undefined
                ]), 1032, ["class", "dense"]))
                : _createCommentVNode("", true);
        };
    }
});
